import React from 'react';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { colors } from '../../config/theme';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1300;
  background: ${colors.surface};
  color: ${colors.textPrimary};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  transform: translateX(${({ open }) => (open ? '0' : '100%')});
  transition: transform 300ms ease;
  pointer-events: ${({ open }) => (open ? 'auto' : 'none')};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  min-height: 56px;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 8px;
  background: ${colors.surface};
  z-index: 1;
`;

const Content = styled.div`
  flex: 1;
  padding: 8px 16px 32px;
`;

const SlidePage = ({ open, onClose, title, children }) => {
  return (
    <Overlay open={open} aria-hidden={!open}>
      <Header>
        <IconButton onClick={onClose} size="small">
          <ArrowBack style={{ color: colors.textPrimary }} />
        </IconButton>
        <Typography variant="subtitle1" style={{ marginLeft: '8px' }}>
          {title}
        </Typography>
      </Header>
      <Content>{children}</Content>
    </Overlay>
  );
};

export default SlidePage;
